import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'fronton-react';
import { useSelector } from 'react-redux';
import { getStoreServices } from 'features/store/ducks/get-store-by-id';
import { getTitle } from 'features/page-model/ducks/get-model';
import { analyticsUtils, patchUrlByLocale } from 'utils';
import { IconByName } from 'utils/hocs';
import {
  greenRound,
  servicesHeader,
  servicesMainRow,
  storeServicesList,
  storeServicesMainContainer,
} from './styles';

export const StoreServicesMain: FC = () => {
  const { t } = useTranslation();
  const services = useSelector(getStoreServices);
  const title = useSelector(getTitle);
  const caption = t('services');

  const handleClick = useCallback(
    (text: string) => {
      analyticsUtils.sendEvent('GA:clickButton', {
        elementType: 'button',
        elementBlock: 'shopPage', // блок, в котором расположен элемент
        elementName: `${title} / ${caption}`, // название блока
        elementText: text, // текст кнопки
      });
    },
    [title, caption],
  );

  if (!services?.length) {
    return null;
  }
  return (
    <div data-qa="store-services-main" className={storeServicesMainContainer}>
      <Typography color="text-primary" variant="h3" className={servicesHeader}>
        {caption}
      </Typography>
      <div className={storeServicesList}>
        {services.map((service) => (
          <a
            className={servicesMainRow}
            href={patchUrlByLocale(service.pagePath)}
            key={service.name}
            data-qa="service-link"
            onClick={() => handleClick(service.name)}
          >
            <div className={greenRound}>
              <IconByName name={service.icon} color="text-primary" />
            </div>
            <Typography color="text-primary" variant="m" size="body_long">
              {service.name}
            </Typography>
          </a>
        ))}
      </div>
    </div>
  );
};
